import React from 'react';

function LostLeadsDonut({ data, size=160 }) {
  const total = data.reduce((s,d)=>s+d.count,0);
  if (total===0) return null;
  const cx=size/2, cy=size/2, r=size/2*0.72, ir=r*0.54;
  let angle=-Math.PI/2;
  const slices = data.filter(d=>d.count>0).map(d => {
    const sweep = (d.count/total)*2*Math.PI;
    const x1=cx+r*Math.cos(angle), y1=cy+r*Math.sin(angle);
    const ix1=cx+ir*Math.cos(angle), iy1=cy+ir*Math.sin(angle);
    angle+=sweep;
    const x2=cx+r*Math.cos(angle), y2=cy+r*Math.sin(angle);
    const ix2=cx+ir*Math.cos(angle), iy2=cy+ir*Math.sin(angle);
    const large=sweep>Math.PI?1:0;
    const path=`M${x1} ${y1}A${r} ${r} 0 ${large} 1 ${x2} ${y2}L${ix2} ${iy2}A${ir} ${ir} 0 ${large} 0 ${ix1} ${iy1}Z`;
    return {...d, path};
  });
  return <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
    {slices.map((s,i)=><path key={i} d={s.path} fill={s.color} stroke="white" strokeWidth="2.5" />)}
    <text x={cx} y={cy-6} textAnchor="middle" fontSize="22" fontWeight="bold" fill="#1D1D1F">{total}</text>
    <text x={cx} y={cy+12} textAnchor="middle" fontSize="11" fill="#8E8E93">perdidos</text>
  </svg>;
}

export { LostLeadsDonut };
